import { AppCardLarge } from "fleet/view/application/large-card";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { EDIT_APPLICATION, icon } from "redux-store/applications";
import { getAuthUser } from "redux-store/auth/selectors";
import { isAdmin } from "redux-store/users/selectors";

function mapStateToProps(state, props) {
  const { app } = props;
  const appIcon = icon(app);
  const user = getAuthUser(state);
  const userIsAdmin = isAdmin(user);

  return {
    icon: appIcon,
    isAdmin: userIsAdmin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    editApp: (serviceArgs) => {
      const { id, operation, isInstalled } = serviceArgs;

      return createPromiseApiAction(dispatch, EDIT_APPLICATION, [
        id,
        operation,
        isInstalled,
      ]);
    },
  };
}

const ConnectedAppCard = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppCardLarge);

export { ConnectedAppCard };
